import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

interface CoreState {
  displayLoading: boolean;
  animationLoading: boolean;
}

const initialState: CoreState = {
  displayLoading: false,
  animationLoading: true,
};

export const CoreStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(store => ({
    openLoading(): void {
      patchState(store, { displayLoading: true });
    },
    closeLoading(): void {
      patchState(store, { displayLoading: false });
    },
    startLoadingAnimation(): void {
      patchState(store, { animationLoading: true });
    },
    stopLoadingAnimation(): void {
      patchState(store, { animationLoading: false });
    },
  }))
);
